import React from "react";
import PropTypes from "prop-types";
import { PHARMACY_HALO_COLORS } from "../config/colors";

const PharmacyHaloButton = ({
  type = "button",
  className = "",
  children,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={`px-5 py-2 font-semibold rounded-lg shadow-md transition duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 ${className}`}
      style={{
        backgroundColor: disabled
          ? `${PHARMACY_HALO_COLORS.BLUE}80`
          : PHARMACY_HALO_COLORS.BLUE,
        color: PHARMACY_HALO_COLORS.YELLOW,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = PHARMACY_HALO_COLORS.YELLOW;
          e.currentTarget.style.color = PHARMACY_HALO_COLORS.BLUE;
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = PHARMACY_HALO_COLORS.BLUE;
          e.currentTarget.style.color = PHARMACY_HALO_COLORS.YELLOW;
        }
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

PharmacyHaloButton.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default PharmacyHaloButton;
